import styled from 'styled-components'
import { colors } from 'Common/constants'
import { Form, Row, Button } from 'antd'

export const StyledH1 = styled.h1`
  font-size: 1.7rem;
  color: ${colors.main};
  text-align: center;
`

export const StyledRow = styled(Row)`
  margin-bottom: 16px;
`

export const StyledForm = styled(Form)`
  padding: 8px 16px 16px 16px !important;
  margin-bottom: 16px !important;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
`

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 12px !important;
  .ant-form-item-label {
    line-height: normal;
    padding-bottom: 4px;
  }
  .ant-form-item-label label {
    text-transform: uppercase;
    font-weight: 500;
    color: ${colors.grey4};
  }
`

export const StyledButton = styled(Button)`
  width: 100%;
  margin-bottom: 16px;
`

export const ActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
`
